import { colors, fonts } from '@grupoboticario/flora-tokens/dist/vult/web/ds'

export const vult = {
  colors,
  fonts,
}
